/* =================================================================
   UVORA — MAIN JS
   Cart drawer + AJAX cart + quiz + variant picker
   ================================================================= */

(function () {
  'use strict';

  // ====================================================
  // HELPERS
  // ====================================================

  function emitCartUpdated(cart) {
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
  }

  // El drawer se busca CADA VEZ, no una sola vez al cargar: si la seccion se
  // re-renderiza (Theme Editor, shopify:section:load) la referencia vieja
  // queda huerfana y los botones dejan de responder.
  function drawerEl() { return document.querySelector('[data-cart-drawer]'); }
  function overlayEl() { return document.querySelector('[data-cart-drawer-overlay]'); }

  // Todo endpoint de carrito pasa por aca: si Shopify responde con error
  // (422 sin stock, linea inexistente, etc.) se LANZA en vez de seguir de
  // largo con un objeto de error como si fuera un carrito valido.
  async function jsonOrThrow(res, fallbackMsg) {
    var data = null;
    try { data = await res.json(); } catch (e) {}
    if (!res.ok) {
      throw new Error((data && (data.description || data.message)) || fallbackMsg);
    }
    return data;
  }

  async function fetchCart() {
    var res = await fetch('/cart.js', {
      headers: { 'Accept': 'application/json' },
      cache: 'no-store'
    });
    return jsonOrThrow(res, 'No pudimos leer el carrito');
  }

  // Endpoints SIEMPRE con sufijo .js (regla 104).
  async function addItems(items) {
    var res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    });
    return jsonOrThrow(res, 'No pudimos agregar al carrito');
  }

  // /cart/change.js recibe la LINE KEY en `id`, nunca el indice de linea:
  // el indice se corre cuando el carrito cambia entre el render y el click
  // (doble toque en mobile) y termina borrando la linea equivocada.
  async function changeLine(key, quantity) {
    var res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    });
    return jsonOrThrow(res, 'No pudimos actualizar el carrito');
  }

  async function updateLines(updates) {
    var res = await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ updates: updates })
    });
    return jsonOrThrow(res, 'No pudimos actualizar el carrito');
  }

  // UN SOLO BUNDLE ACTIVO: borra toda linea del producto antes de agregar la
  // nueva. Sin esto /cart/add.js es aditivo por definicion y el comprador
  // termina con dos o tres ofertas cargadas.
  async function replaceProductLines(cart, productId) {
    if (!productId) return cart;
    var pid = String(productId);
    var updates = {};
    var found = false;
    (cart.items || []).forEach(function (it) {
      if (String(it.product_id) === pid) { updates[it.key] = 0; found = true; }
    });
    if (!found) return cart;
    return updateLines(updates);
  }

  // Punto de entrada unico de compra. Lo usan el boton del hero, el sticky
  // ATC y cualquier otro boton del tema, asi no pueden divergir nunca mas.
  async function addBundle(opts) {
    opts = opts || {};
    var items = (opts.items || []).filter(function (i) { return i && i.id; });
    if (!items.length) throw new Error('Elegi un plan para continuar.');

    var cart = await fetchCart();
    cart = await replaceProductLines(cart, opts.replaceProductId);
    await addItems(items);
    cart = await fetchCart();

    emitCartUpdated(cart);
    await openDrawer(cart);
    return cart;
  }

  function formatARS(cents) {
    try {
      return new Intl.NumberFormat('es-AR', {
        style: 'currency', currency: 'ARS',
        minimumFractionDigits: 0, maximumFractionDigits: 0
      }).format(cents / 100);
    } catch (e) {
      return '$' + Math.round(cents / 100).toLocaleString('es-AR');
    }
  }

  function esc(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  // ====================================================
  // CART DRAWER
  // ====================================================

  // Candado: mientras hay una peticion en vuelo se ignoran los clicks
  // siguientes. Sin esto, el doble toque de mobile manda dos cambios sobre
  // un carrito que ya se movio.
  var cartBusy = false;

  // El cartel de "carrito vacio" se toma del HTML que ya renderiza
  // cart-drawer.liquid: una sola fuente de verdad para ese texto, en vez de
  // tenerlo escrito tambien aca (era lo que permitia que se desincronizaran).
  var emptyHTML = null;

  function captureEmptyState() {
    if (emptyHTML !== null) return;
    var d = drawerEl();
    if (!d) return;
    var body = d.querySelector('[data-cart-body]');
    if (body) emptyHTML = body.innerHTML;
  }

  function showCartError(msg) {
    var d = drawerEl();
    if (!d) return;
    var box = d.querySelector('[data-cart-error]');
    if (!box) { if (msg) console.error('[uvora]', msg); return; }
    if (!msg) { box.textContent = ''; box.style.display = 'none'; return; }
    box.textContent = msg;
    box.style.display = '';
    clearTimeout(box.__t);
    box.__t = setTimeout(function () { box.style.display = 'none'; }, 5000);
  }

  // Countdown state
  var countdownInterval = null;
  var countdownEnd = null;

  // Minutos de la cuenta regresiva: ajuste "Minutos" del carrito (15 por defecto).
  function countdownMinutes() {
    var el = document.querySelector('[data-cart-countdown]');
    return (el && parseInt(el.getAttribute('data-countdown-minutes'), 10)) || 15;
  }

  function startCountdown() {
    var el = document.querySelector('[data-cart-countdown]');
    if (!el) return;
    countdownEnd = Date.now() + countdownMinutes() * 60 * 1000;
    if (countdownInterval) clearInterval(countdownInterval);
    updateCountdown();
    countdownInterval = setInterval(updateCountdown, 1000);
  }

  function updateCountdown() {
    var el = document.querySelector('[data-cart-countdown]');
    if (!el || !countdownEnd) return;
    var ms = Math.max(0, countdownEnd - Date.now());
    var m = Math.floor(ms / 60000);
    var s = Math.floor((ms % 60000) / 1000);
    el.textContent = String(m).padStart(2, '0') + ':' + String(s).padStart(2, '0');
    if (ms <= 0) {
      // Reset countdown silently to keep urgency
      countdownEnd = Date.now() + countdownMinutes() * 60 * 1000;
    }
  }

  // Personas mirando: arranca entre el minimo y el maximo de los ajustes del
  // carrito (18 y 32 por defecto) y fluctua hasta 6 por debajo/encima.
  function startViewersCount() {
    var el = document.querySelector('[data-viewers-count]');
    if (!el) return;
    var vMin = parseInt(el.getAttribute('data-viewers-min'), 10) || 18;
    var vMax = parseInt(el.getAttribute('data-viewers-max'), 10) || 32;
    if (vMax <= vMin) vMax = vMin + 1;
    var count = vMin + Math.floor(Math.random() * (vMax - vMin));
    el.textContent = count;
    setInterval(function () {
      var delta = Math.floor(Math.random() * 5) - 2;
      count = Math.max(Math.max(1, vMin - 6), Math.min(vMax + 6, count + delta));
      el.textContent = count;
    }, 3500 + Math.random() * 2000);
  }

  // Abrir SIEMPRE repinta antes de mostrar: si no, el comprador ve el cartel
  // de "carrito vacio" que vino del servidor aunque acabe de agregar algo.
  async function openDrawer(cart) {
    try { await refreshDrawer(cart); } catch (e) { console.error(e); }
    showDrawer();
  }

  function showDrawer() {
    var drawer = drawerEl();
    if (!drawer) return;
    var overlay = overlayEl();
    drawer.classList.add('is-open');
    if (overlay) overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    drawer.setAttribute('aria-hidden', 'false');
    startCountdown();
    // Focus on close button for a11y
    var closeBtn = drawer.querySelector('[data-cart-close]');
    if (closeBtn) setTimeout(function () { closeBtn.focus(); }, 300);
  }

  function closeDrawer() {
    var drawer = drawerEl();
    if (!drawer) return;
    var overlay = overlayEl();
    drawer.classList.remove('is-open');
    if (overlay) overlay.classList.remove('is-open');
    document.body.style.overflow = '';
    drawer.setAttribute('aria-hidden', 'true');
  }

  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.style.display = count > 0 ? '' : 'none';
    });
  }

  function updateShippingBar(cart) {
    var wrap = document.querySelector('[data-cart-shipping]');
    var fill = document.querySelector('[data-shipping-fill]');
    var text = document.querySelector('[data-shipping-text]');
    var span = text ? text.querySelector('span') : null;

    // El umbral sale del setting de la sección cart-drawer. Antes estaba
    // hardcodeado en "siempre gratis" y el setting no hacía nada (setting
    // fantasma). Con umbral 0 el comportamiento es idéntico al de antes.
    var threshold = wrap ? parseInt(wrap.getAttribute('data-free-shipping-threshold'), 10) || 0 : 0;
    var unlockedText = (wrap && wrap.getAttribute('data-shipping-unlocked-text')) || '¡Envío gratis desbloqueado!';
    var progressText = (wrap && wrap.getAttribute('data-shipping-progress-text')) || 'Te faltan [falta] para el envío gratis';

    var subtotal = cart && typeof cart.total_price === 'number' ? cart.total_price : 0;

    if (threshold <= 0 || subtotal >= threshold) {
      if (fill) fill.style.width = '100%';
      if (span) span.textContent = unlockedText;
      return;
    }

    var pct = Math.max(0, Math.min(100, (subtotal / threshold) * 100));
    if (fill) fill.style.width = pct.toFixed(1) + '%';
    if (span) span.textContent = progressText.replace('[falta]', formatARS(threshold - subtotal));
  }

  function updateBonus(cart) {
    var bonusEl = document.querySelector('[data-cart-bonus]');
    if (!bonusEl) return;
    // Desde N unidades (ajuste del carrito, 2 por defecto): bonus desbloqueado
    var d = drawerEl();
    var minItems = (d && parseInt(d.getAttribute('data-bonus-min-items'), 10)) || 2;
    if (cart.item_count >= minItems) {
      bonusEl.style.display = 'flex';
    } else {
      bonusEl.style.display = 'none';
    }
  }

  function updateSavings(cart) {
    var savingsRow = document.querySelector('[data-cart-savings]');
    var savingsAmount = document.querySelector('[data-cart-savings-amount]');
    if (!savingsRow) return;

    // Ahorro = descuentos realmente aplicados en el carrito (por linea y
    // sobre el total). Antes se sumaba (original - final) MAS
    // line_level_total_discount, que son el mismo descuento contado dos
    // veces: con un descuento activo el carrito mostraba el doble de ahorro.
    var totalSavings = 0;
    if (typeof cart.original_total_price === 'number' && typeof cart.total_price === 'number') {
      totalSavings = cart.original_total_price - cart.total_price;
    } else {
      (cart.items || []).forEach(function (item) {
        if (item.original_line_price && item.final_line_price) {
          totalSavings += (item.original_line_price - item.final_line_price);
        }
      });
    }

    if (totalSavings > 0) {
      savingsRow.style.display = 'flex';
      if (savingsAmount) savingsAmount.textContent = formatARS(totalSavings);
    } else {
      savingsRow.style.display = 'none';
    }
  }

  function updateInstallments(cart) {
    var insRow = document.querySelector('[data-cart-installments]');
    var insAmount = document.querySelector('[data-cart-installment-amount]');
    if (!insRow) return;
    var d = drawerEl();
    var cuotas = (d && parseInt(d.getAttribute('data-installments-count'), 10)) || 3;
    if (cart.total_price > 0) {
      insRow.style.display = 'block';
      if (insAmount) insAmount.textContent = formatARS(Math.round(cart.total_price / cuotas));
    } else {
      insRow.style.display = 'none';
    }
  }

  // Cada linea lleva su LINE KEY en data-cart-key. Los botones no guardan
  // ningun numero de linea: el handler lee la key del contenedor.
  function renderItem(item) {
    var hasDiscount = item.original_line_price > item.final_line_price;
    var img = item.image
      ? '<img src="' + esc(item.image.replace(/(\.[^.]+)$/, '_120x$1')) + '" alt="' + esc(item.title) + '" loading="lazy" width="60" height="60">'
      : '';
    var variantLine = (item.variant_title && item.variant_title !== 'Default Title')
      ? '<p class="cart-item__variant">' + esc(item.variant_title) + '</p>'
      : '';
    var oldPrice = hasDiscount
      ? '<span class="cart-item__price-old">' + formatARS(item.original_line_price) + '</span>'
      : '';
    var d = drawerEl();
    var removeText = (d && d.getAttribute('data-remove-text')) || 'Quitar';

    return '' +
      '<div class="cart-item" data-cart-key="' + esc(item.key) + '">' +
        '<div class="cart-item__img">' + img + '</div>' +
        '<div class="cart-item__info">' +
          '<p class="cart-item__name">' + esc(item.product_title) + '</p>' +
          variantLine +
          '<div class="cart-item__qty">' +
            '<button type="button" data-cart-decrease aria-label="Restar uno">−</button>' +
            '<span aria-live="polite">' + item.quantity + '</span>' +
            '<button type="button" data-cart-increase aria-label="Sumar uno">+</button>' +
          '</div>' +
        '</div>' +
        '<div class="cart-item__price-wrap">' +
          '<span class="cart-item__price">' + formatARS(item.final_line_price) + '</span>' +
          oldPrice +
          '<button type="button" class="cart-item__remove" data-cart-remove aria-label="' + esc(removeText) + '">' + esc(removeText) + '</button>' +
        '</div>' +
      '</div>';
  }

  async function refreshDrawer(cart) {
    var drawer = drawerEl();
    if (!drawer) return;
    captureEmptyState();

    if (!cart) cart = await fetchCart();

    updateCartCount(cart.item_count);
    updateShippingBar(cart);
    updateBonus(cart);
    updateSavings(cart);
    updateInstallments(cart);

    var body = drawer.querySelector('[data-cart-body]');
    var foot = drawer.querySelector('[data-cart-foot]');
    if (!body) return;

    if (cart.item_count === 0) {
      if (emptyHTML !== null) body.innerHTML = emptyHTML;
      if (foot) foot.style.display = 'none';
      return;
    }

    if (foot) foot.style.display = '';
    body.innerHTML = (cart.items || []).map(renderItem).join('');

    var subtotalEl = drawer.querySelector('[data-cart-subtotal]');
    if (subtotalEl) subtotalEl.textContent = formatARS(cart.total_price);
  }

  // Open / close triggers (delegated)
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-toggle]')) {
      e.preventDefault();
      openDrawer();
      return;
    }
    if (e.target.closest('[data-cart-close]')) {
      e.preventDefault();
      closeDrawer();
    }
  });

  // ESC closes drawer
  document.addEventListener('keydown', function (e) {
    var drawer = drawerEl();
    if (e.key === 'Escape' && drawer && drawer.classList.contains('is-open')) {
      closeDrawer();
    }
  });

  // Acciones de linea: cantidad y quitar. Delegado en document para que
  // sobreviva a cualquier re-render del drawer.
  document.addEventListener('click', async function (e) {
    var btn = e.target.closest('[data-cart-remove], [data-cart-increase], [data-cart-decrease]');
    if (!btn) return;
    var row = btn.closest('[data-cart-key]');
    if (!row) return;

    e.preventDefault();
    if (cartBusy) return;

    var key = row.getAttribute('data-cart-key');
    if (!key) return;

    cartBusy = true;
    row.setAttribute('aria-busy', 'true');
    showCartError('');

    try {
      var qty = 0;
      if (!btn.hasAttribute('data-cart-remove')) {
        // La cantidad se relee del carrito real, no del numero pintado:
        // el DOM puede estar viejo respecto del carrito.
        var current = await fetchCart();
        var line = (current.items || []).filter(function (it) { return it.key === key; })[0];
        if (!line) { await refreshDrawer(current); return; }
        qty = btn.hasAttribute('data-cart-increase') ? line.quantity + 1 : line.quantity - 1;
        if (qty < 0) qty = 0;
      }

      var updated = await changeLine(key, qty);
      emitCartUpdated(updated);
      await refreshDrawer(updated);
    } catch (err) {
      console.error(err);
      showCartError(err.message || 'No pudimos actualizar el carrito');
      try { await refreshDrawer(); } catch (e2) {}
    } finally {
      cartBusy = false;
      row.removeAttribute('aria-busy');
    }
  });

  // Listen for cart updates from anywhere. Si el drawer esta abierto se
  // repinta: asi la limpieza de upsells del hero y el drawer dejan de
  // pisarse (antes el drawer podia quedar mostrando una foto vieja).
  var refreshQueued = false;
  document.addEventListener('cart:updated', function (e) {
    if (e.detail && typeof e.detail.item_count === 'number') updateCartCount(e.detail.item_count);
    var drawer = drawerEl();
    if (!drawer || !drawer.classList.contains('is-open')) return;
    if (refreshQueued) return;
    refreshQueued = true;
    setTimeout(function () {
      refreshQueued = false;
      refreshDrawer().catch(function () {});
    }, 0);
  });

  // Initial count load
  captureEmptyState();
  fetchCart().then(function (c) { updateCartCount(c.item_count); }).catch(function () {});

  // Start viewers count
  startViewersCount();

  // API publica: todas las secciones compran por aca (regla 34).
  window.UvoraCart = {
    get: fetchCart,
    add: addItems,
    addBundle: addBundle,
    changeLine: changeLine,
    refresh: refreshDrawer,
    open: openDrawer,
    close: closeDrawer,
    error: showCartError
  };

  // ====================================================
  // ADD TO CART (botones sueltos de otras secciones)
  // ====================================================

  document.addEventListener('click', async function (e) {
    var addBtn = e.target.closest('[data-whisp-tier-add], [data-add-to-cart]');
    if (!addBtn) return;
    e.preventDefault();

    if (addBtn.hasAttribute('aria-busy')) return;

    var variantId = addBtn.getAttribute('data-variant-id');
    if (!variantId) {
      console.warn('[uvora] variant ID missing');
      return;
    }

    addBtn.setAttribute('aria-busy', 'true');
    var txtSpan = addBtn.querySelector('.whisp-tier-card__cta-text, .add-to-cart-text');
    var original = txtSpan ? txtSpan.textContent : addBtn.textContent;
    if (txtSpan) txtSpan.textContent = 'Agregando...';

    try {
      await addBundle({
        items: [{ id: parseInt(variantId, 10), quantity: 1 }],
        replaceProductId: addBtn.getAttribute('data-product-id') || null
      });
      if (txtSpan) txtSpan.textContent = original;
    } catch (err) {
      console.error(err);
      showCartError(err.message || 'Hubo un problema. Probá de nuevo.');
      if (txtSpan) txtSpan.textContent = original;
    } finally {
      addBtn.removeAttribute('aria-busy');
    }
  });

  // ====================================================
  // QUIZ
  // ====================================================

  const quiz = document.querySelector('[data-quiz]');
  if (quiz) {
    const answers = {};
    quiz.addEventListener('click', function (e) {
      const opt = e.target.closest('[data-quiz-option]');
      if (!opt) return;
      const step = opt.getAttribute('data-step');
      const value = parseInt(opt.getAttribute('data-value'), 10);
      answers[step] = value;
      const nextStep = parseInt(step, 10) + 1;
      const allSteps = quiz.querySelectorAll('[data-quiz-step]');
      const progressBar = quiz.querySelector('[data-quiz-progress]');
      allSteps.forEach(s => s.classList.remove('is-active'));
      if (nextStep <= 3) {
        const next = quiz.querySelector(`[data-quiz-step="${nextStep}"]`);
        if (next) next.classList.add('is-active');
        if (progressBar) progressBar.style.width = (nextStep * 33) + '%';
      } else {
        const result = quiz.querySelector('[data-quiz-step="result"]');
        if (result) result.classList.add('is-active');
        if (progressBar) progressBar.style.width = '100%';
        const total = (answers['1'] || 0) + (answers['2'] || 0) + (answers['3'] || 0);
        const planEl = quiz.querySelector('[data-quiz-result-plan]');
        const priceEl = quiz.querySelector('[data-quiz-result-price]');
        let plan = 'Plan Inicio', price = '$34.990';
        if (total >= 7) { plan = 'Plan Transformación'; price = '$79.990'; }
        else if (total >= 4) { plan = 'Plan Resultados'; price = '$59.990'; }
        if (planEl) planEl.textContent = plan;
        if (priceEl) priceEl.textContent = price;
      }
    });
    const restart = quiz.querySelector('[data-quiz-restart]');
    if (restart) {
      restart.addEventListener('click', function () {
        quiz.querySelectorAll('[data-quiz-step]').forEach(s => s.classList.remove('is-active'));
        const f = quiz.querySelector('[data-quiz-step="1"]');
        if (f) f.classList.add('is-active');
        const pb = quiz.querySelector('[data-quiz-progress]');
        if (pb) pb.style.width = '33%';
      });
    }
  }

  // ====================================================
  // FAQ — auto close others
  // ====================================================

  document.querySelectorAll('.faq-item').forEach(item => {
    item.addEventListener('toggle', function () {
      if (item.open) {
        document.querySelectorAll('.faq-item[open]').forEach(other => {
          if (other !== item) other.removeAttribute('open');
        });
      }
    });
  });

  // ====================================================
  // PRODUCT VARIANT PICKER
  // ====================================================

  document.querySelectorAll('[data-variant-picker]').forEach(picker => {
    picker.addEventListener('click', function (e) {
      const btn = e.target.closest('[data-variant]');
      if (!btn) return;
      picker.querySelectorAll('[data-variant]').forEach(b => b.classList.remove('is-active'));
      btn.classList.add('is-active');
      const variantId = btn.getAttribute('data-variant');
      const price = btn.getAttribute('data-price');
      const priceOld = btn.getAttribute('data-price-old');
      const priceEl = document.querySelector('[data-product-price]');
      const priceOldEl = document.querySelector('[data-product-price-old]');
      const addBtn = document.querySelector('[data-add-to-cart]');
      if (priceEl && price) priceEl.textContent = price;
      if (priceOldEl && priceOld) priceOldEl.textContent = priceOld;
      if (addBtn && variantId) addBtn.setAttribute('data-variant-id', variantId);
    });
  });

})();
